<template>
    <div class="d-block text-center">
      <b-container fluid>
      <b-button v-b-modal.modal-1>Export du fichier Csv de la periode</b-button>
        <b-modal id="modal-1" title="BootstrapVue">
          <p class="my-4">Hello from modal!</p>
          <select v-model="selected" @click="showModal">
          <option v-for="option in options" v-bind:value="option">
            {{ option }}
            </option>
          </select>
        </b-modal>
      </b-container>
      <span>Sélectionné : {{ selected }}</span>
    </div>
</template>

<script>
import server from '../../api/server.vue'
import { saveAs } from 'file-saver'

export default {
  name: 'CsvModalExport',
  data() {
    return {
      kanban: null,
      loading: false,
      selected:'',
      options: [1, 3, 6]
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
    showModal () {
      server.exportCsvKanbanStat(this.selected).then((response) => {
        let contentDispo = response.headers['content-disposition'].split('filename=')
        contentDispo = contentDispo[1].substring(0, contentDispo[1].length-1)
        saveAs(response.data, contentDispo)
        this.$toasted.success('Données exportées.')
      })
      .catch((e) => {
        this.$toasted.error('Erreur...')
        console.error(e)
      })
    },
 },
  mounted: function() {
   
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// CsvModalExport.vue?b52301e2